import { render, staticRenderFns } from "./softList.vue?vue&type=template&id=bea0b9ac&scoped=true"
import script from "./softList.vue?vue&type=script&lang=js"
export * from "./softList.vue?vue&type=script&lang=js"
import style0 from "./softList.vue?vue&type=style&index=0&id=bea0b9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea0b9ac",
  null
  
)

export default component.exports